<template>
	<vxe-modal :loading="loading" v-model="modal" width="600" height="auto" @show="show" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<el-form ref="form" :model="form" label-width="80px" size="mini">
				<el-form-item label="代发仓库">
					<el-input readonly v-model="form.warehouse"></el-input>
				</el-form-item>
				<el-form-item label="代发供应商">
					<el-input v-model="supplier.name" readonly>
						<el-button slot="append" icon="el-icon-search" @click="suppliersearch"></el-button>
					</el-input>
				</el-form-item>
				<el-form-item label="收件人">
					<el-input type="textarea" placeholder="自定义收件人" v-model="recipient" @input="getcontent"></el-input>
				</el-form-item>
				<el-form-item required label="内容">
					<el-input v-model="form.content" type="textarea" :rows="10"></el-input>
				</el-form-item>
				<el-form-item label="发送测绘图">
					<el-switch v-model="form.modelimg" @change="modelimgChange" active-text="是" inactive-text="否">
					</el-switch>
				</el-form-item>
			</el-form>
			<supplier-box ref="supplierbox" @submit="suppliersubmit" />
		</template>
		<template #footer>
			<vxe-button status="danger" content="创建采购单" @click="purchase"></vxe-button>
			<vxe-button status="success" content="复制" @click="copy"></vxe-button>
			<vxe-button status="primary" content="发送" @click="send"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import supplierBox from './box/supplierbox.vue'
	export default {
		props: {
			componentStore: {
				default: () => {
					return null
				}
			},
			row: {
				default: () => {
					return []
				}
			},
			detail: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				title: '报货话术',
				recipient: "",
				supplier: {
					name: null,
					id: null
				},
				form: {
					content: '',
					warehouse: null,
					modelimg:false
				},
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			purchase(){
				let notice = '是否确认创建采购单？'
				if(this.row.purchasecode){
					notice = '采购单已创建，是否确认重新创建？'
				}						
				this.$confirm(notice).then(()=>{
					if(!this.supplier.id){
						this.$message.error('请选择供应商')
						return
					}else{
						this.loading = true					
						this.$api.agencysendwarehouse.createpurchase({
							order: this.row,
							detail:this.detail,
							supplier:this.supplier
						}).then(()=>{
							this.$message.success('创建成功')
							this.componentStore.customreload()
							this.loading = false
						},()=>{
							this.loading = false
						})
					}
				})	
			},

			suppliersearch() {
				//alert(123)
				this.$refs.supplierbox.box.alertBox()
			},
			suppliersubmit(e) {
				this.supplier = {
					id: e.data.id,
					name: e.data.name,
					wlnid: e.data.wlnid,
				}
				this.supplierChange().then((res) => {
					this.detail.forEach((item) => {
						item.price1 = null
						let exist = res.find((_item) => {
							return _item.code == item.spec_code
						})
						if (exist) {
							item.price1 = exist.price1
						}
					})
					this.title = '代发话术【' + this.row.storage_name + '】'
					this.form.warehouse = this.row.storage_name
					this.componentStore.getcontent(this.row, this.detail, this.recipient).then((content) => {
						this.form.content = content
					})
				})
				//console.log(e)
			},
			init() {

			},
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')
			},
			show() {

			},
			modelimgChange(){
				this.getcontent()
			},
			modalShow() {
				this.recipient = ""
				this.supplier = {
					name: null,
					id: null,
					wlnid: null,
				}
				this.form = {
					content: '',
					warehouse: null
				}
				this.getcontent()
				this.modal = true
			},
			getcontent() {			
				let goodscodes = this.detail.map((item) => {
					return item.spec_code
				})
				this.loading = true
				this.$api.agencysendwarehouse.getbestsupplier({
					goodscode: goodscodes.join(',')
				}).then((res) => {
					this.loading = false
					if (res && res.length == 1) {
						this.supplier = res[0]
					}		
					this.supplierChange().then((res) => {
						this.detail.forEach((item) => {
							item.price1 = null
							let exist = res.find((_item) => {
								return _item.code == item.spec_code
							})
							if (exist) {
								item.price1 = exist.price1
							}
						})
						this.title = '代发话术【' + this.row.storage_name + '】'
						this.form.warehouse = this.row.storage_name
						this.componentStore.getcontent(this.row, this.detail, this.recipient,this.form.modelimg).then((
							content) => {
							this.form.content = content
						})
					})
				},()=>{
					this.loading = false
				})


			},
			supplierChange() {
				return new Promise((reslove) => {
					if (this.row.storage_uid == '6A62605D9BB83561AC93DCEE70535ED1') {
						let goodscode = this.detail.map((item) => {
							return item.spec_code
						})
						this.$api.agencysendwarehouse.getcostbysupplierid({
							goodscode: goodscode.join(','),
							supplierid: this.supplier.id
						}).then((res) => {
							//console.log(res)
							reslove(res)
						})
					}else{
						reslove([])
					}
					
				})




				//console.log(this.supplier.id, goodscode, this.row.storage_uid)
			},
			send() {
				if (!this.form.content || !this.supplier.id) {
					this.$message.error('供应商与内容必填')
					return
				}
				this.$api.agencysendwarehouse.reportgoods({
					detail: this.detail.map((item) => {
						return {
							sys_sku_id: item.sys_sku_id,
							sys_trade: item.sys_trade,
							sys_shop: item.sys_shop,
						}
					}),
					salercpt_uid: this.row.salercpt_uid,
					salercpt_no: this.row.salercpt_no,
					storage_uid: this.row.storage_uid,
					sums: this.row.sums,
					supplierid: this.supplier.id,
					content: this.form.content,
					type: 'send'
				}).then(() => {
					this.$message.success('发送成功')
				})
			},
			copy() {
				if (!this.form.content) {
					this.$message.error('内容必填')
					return
				}
				this.$copyText(this.form.content).then(() => {
					//this.$message.success('复制成功')
					this.$api.agencysendwarehouse.reportgoods({
						detail: this.detail.map((item) => {
							return {
								sys_sku_id: item.sys_sku_id,
								sys_trade: item.sys_trade,
								sys_shop: item.sys_shop,
							}
						}),
						salercpt_uid: this.row.salercpt_uid,
						salercpt_no: this.row.salercpt_no,
						sums: this.row.sums,
						storage_uid: this.row.storage_uid,
						supplierid: this.supplier.id,
						content: this.form.content,
						type: 'copy'
					}).then(() => {
						this.$message.success('复制成功')
						this.componentStore.customreload()
					})
				}, () => {
					this.$message.success('复制失败')
				})
			}


		},
		components: {
			supplierBox
		}
	}
</script>